import React, { DOMAttributes } from 'react';
import styled from 'styled-components'

interface LinkInterface extends DOMAttributes<any> {
    cursor?: string;
    paddingLeft?: string;
    paddingRight?: string;
    style?: React.CSSProperties
    title?: string
    onClick?: () => void
}

interface SLinkInterface {
    $cursor?: string;
    $paddingLeft?: string;
    $paddingRight?: string;
    $title?: string
    $onClick?: () => void
}



const SStyledLink = styled.div<SLinkInterface>`
    padding-left: ${props => props.$paddingLeft ?? '0px'};
    padding-right: ${props => props.$paddingRight ?? '0px'};
    cursor: ${props =>  props.$cursor ?? 'pointer'};
    title:  ${props =>  props.$title};
`;

const StyledLink: React.FC<LinkInterface> = (props) => {
    const {title,cursor,paddingRight, paddingLeft,children} = props
    return (
        <SStyledLink
            $cursor={cursor}
            $paddingLeft={paddingLeft}
            $paddingRight={paddingRight}
            $title={title}
            onClick={props.onClick}
        >
            {children}
        </SStyledLink>
    )
}


export default StyledLink;
